import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .InteractiveHome_Wrapper {
     width: 100%;
     padding: 0 0;
     background-color: ${colors.neutral};
     @media(min-width: 1024px) {
       padding: 0 0;
     }
   }
   .InteractiveHome {
     width: 100%;
     padding-top: 65.43%;
     iframe {
       position: absolute;
       top: 0;
       bottom: 0;
       left: 0;
       width: 100%;
       height: 100%;
       border: 0;
     }
   }

`;

function InteractiveHome({ content }) {
  return (
    <section className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} />
      }
      {
        get(content, '[0].iframe_url') &&
        <div className="container">
          <div className="row justify-content-center">
            <div className="InteractiveHome_Wrapper">
              <div className="position-relative">
                <div className="InteractiveHome">
                  <iframe scrolling="no" title="Smart Home" src={get(content, '[0]iframe_url')} />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </section>
  );
}

InteractiveHome.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default InteractiveHome;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/InteractiveHome.section.js